/**
 * NoData Component
 * Premium empty state - with gentle guidance
 * Used within tables and lists
 */

import React from 'react';
import { Empty } from 'antd';

/**
 * NoData Component
 *
 * @param {string} description - Empty state description (main message)
 * @param {string} hint - Helper text (guidance for user)
 * @param {ReactNode} image - Custom empty image
 * @param {string} imageStyle - Image style preset ('default' | 'simple')
 * @param {Object} style - Additional styles
 */
function NoData({
  description = 'No items found',
  hint = 'Adjust filters or try again later',
  image,
  imageStyle = 'default',
  style = {},
}) {
  // Use simple image for compact spaces
  const emptyImage = image || (
    imageStyle === 'simple' ? Empty.PRESENTED_IMAGE_SIMPLE : Empty.PRESENTED_IMAGE_DEFAULT
  );

  // Two-line description with guidance
  const fullDescription = hint ? (
    <div>
      <div style={{ fontSize: 14, color: '#17052B', marginBottom: 4 }}>
        {description}
      </div>
      <div style={{ fontSize: 13, color: 'rgba(23, 5, 43, 0.55)' }}>
        {hint}
      </div>
    </div>
  ) : description;

  return (
    <Empty
      image={emptyImage}
      description={fullDescription}
      style={{
        paddingTop: 48,
        paddingBottom: 48,
        ...style,
      }}
    />
  );
}

export default NoData;
